import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Claim } from '@wsphere/warranties/domain';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClaimOverrideRulesService {
  private http = inject(HttpClient);

  async retrieve() {
    return firstValueFrom(this.http.get<Claim.Override.Rules>(`/api/claim-override-rules`));
  }

  async update(rules: Claim.Override.Rules) {
    return firstValueFrom(this.http.patch<Claim.Override.Rules>(`/api/claim-override-rules`, rules));
  }
}
